import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpotsComponent } from './spots.component';
import { SpotsProgComponent } from './spotsProg.component';

import { SpotsService } from '../../providers/spots/spots.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';

import { FullCalendarModule } from '@fullcalendar/angular';

@NgModule({
  declarations: [
    SpotsComponent,
    SpotsProgComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FullCalendarModule,
    MatRadioModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatSnackBarModule,
    MatTableModule,
    MatExpansionModule,
    ReactiveFormsModule
  ],
  providers: [
    SpotsService,
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }
  ]
})
export class SpotsModule { }
